const getPageSpecificValues = (page) => {
  switch (page) {
  case 'homepage':
    return {
      experiments: {
        mcom: '',
        bcom: '1199-21',
      },
      ad_data: {
        mcom: {
          slotId: '22026345640',
          brand: 'mcom',
          mweb: {
            GOOGLE_AD_2: { pos: 'top', width: 335, height: 94 },
            GOOGLE_AD_5: { pos: 'row5', width: 335, height: 94 },
          },
          desktop: {
            GOOGLE_AD_2: { pos: 'top', width: 1600, height: 200 },
            GOOGLE_AD_5: { pos: 'row5', width: 1600, height: 200 },
          },
        },
        bcom: {
          slotId: '22026345640',
          brand: 'bcom',
          mweb: {
            GOOGLE_AD_2: { pos: 'top', width: 343, height: 96 },
          },
          desktop: {
            GOOGLE_AD_2: { pos: 'top', width: 1440, height: 230 },
          },
        },
      },
    };
  case 'search':
    return {
      experiments: {
        mcom: '',
        bcom: '',
      },
      brand_showcase_page_element: [
        { id: 'brandShowCaseMedia', pos: 'brandshowcase' },
      ],
      brand_showcase_banner_element: [
        { id: 'brandShowCaseMedia', pos: 'brandshowcaseimage' },
      ],
      ad_data: {
        mcom: {
          slotId: '22026345640',
          brand: 'mcom',
          mweb: {
            googleAdOnSearchMobileInline_3: {
              pos: 'search_inline1',
              width: 335,
              height: 94,
            },
            googleAdOnSearchMobileInline_6: {
              pos: 'search_inline2',
              width: 335,
              height: 94,
            },
          },
          desktop: {
            googleAdOnSearch: {
              pos: 'search_header',
              width: 1280,
              height: 160,
            },
            googleAdOnSearchInline_3: {
              pos: 'search_inline1',
              width: 954,
              height: 118,
            },
            googleAdOnSearchInline_6: {
              pos: 'search_inline2',
              width: 954,
              height: 118,
            },
          },
        },
        bcom: {
          slotId: '22026345640',
          brand: 'bcom',
          mweb: {
            googleAdOnSearch: {
              pos: 'header',
              width: 343,
              height: 112,
            },
            googleAdOnSearchMobileInline_3: {
              pos: 'inline1',
              width: 343,
              height: 112,
            },
            googleAdOnSearchMobileInline_6: {
              pos: 'inline2',
              width: 343,
              height: 112,
            },
          },
          desktop: {
            googleAdOnSearch: {
              pos: 'header',
              width: 1410,
              height: 198,
            },
            googleAdOnSearchInline_3: {
              pos: 'inline1',
              width: 1170,
              height: 198,
            },
            googleAdOnSearchInline_6: {
              pos: 'inline2',
              width: 1170,
              height: 198,
            },
          },
        },
      },
    };
  case 'browse':
    return {
      experiments: {
        mcom: '',
        bcom: '',
      },
      brand_showcase_page_element: [
        { id: 'brandShowCaseMedia', pos: 'brandshowcase' },
      ],
      brand_showcase_banner_element: [
        { id: 'brandShowCaseMedia', pos: 'brandshowcaseimage' },
      ],
      ad_data: {
        mcom: {
          slotId: '22026345640',
          brand: 'mcom',
          mweb: {
            GOOGLE_AD_3: {
              pos: 'catsplash_header',
              width: 335,
              height: 94,
            },
            googleAdOnSearchMobileInline_3: {
              pos: 'browse_inline1',
              width: 335,
              height: 94,
            },
            googleAdOnSearchMobileInline_6: {
              pos: 'browse_inline2',
              width: 335,
              height: 94,
            },
          },
          desktop: {
            googleAdOnSearch: {
              pos: 'browse_header',
              width: 1280,
              height: 160,
            },
            GOOGLE_AD_3: {
              pos: 'catsplash_header',
              width: 954,
              height: 118,
            },
            googleAdOnSearchInline_3: {
              pos: 'browse_inline1',
              width: 954,
              height: 118,
            },
            googleAdOnSearchInline_6: {
              pos: 'browse_inline2',
              width: 954,
              height: 118,
            },
          },
        },
        bcom: {
          slotId: '22026345640',
          brand: 'bcom',
          mweb: {
            googleAdOnSearch: {
              pos: 'header',
              width: 343,
              height: 112,
            },
            googleAdOnSearchMobileInline_3: {
              pos: 'inline1',
              width: 343,
              height: 112,
            },
            googleAdOnSearchMobileInline_6: {
              pos: 'inline2',
              width: 343,
              height: 112,
            },
          },
          desktop: {
            googleAdOnSearch: {
              pos: 'header',
              width: 1410,
              height: 198,
            },
            googleAdOnSearchInline_3: {
              pos: 'inline1',
              width: 1170,
              height: 198,
            },
            googleAdOnSearchInline_6: {
              pos: 'inline2',
              width: 1170,
              height: 198,
            },
          },
        },
      },
    };
  case 'catsplash':
    return {
      experiments: {
        mcom: '',
        bcom: '',
      },
      ad_data: {
        mcom: {
          slotId: '22026345640',
          brand: 'mcom',
          blockedCatIds: ['5204'],
          mweb: {
            googleAdOnCatsplash: {
              pos: 'catsplash_header',
              width: 335,
              height: 94,
            },
          },
          desktop: {
            googleAdOnCatsplash: {
              pos: 'catsplash_header',
              width: 954,
              height: 118,
            },
          },
        },
        bcom: {
          mweb: {},
          desktop: {},
        },
      },
    };
  case 'subsplash':
    return {
      experiments: {
        mcom: '',
        bcom: '',
      },
      ad_data: {
        mcom: {
          slotId: '22026345640',
          brand: 'mcom',
          mweb: {
            googleAdOnSearchMobileInline_3: {
              pos: 'search_inline1',
              width: 335,
              height: 94,
            },
            googleAdOnSearchMobileInline_6: {
              pos: 'search_inline2',
              width: 335,
              height: 94,
            },
          },
          desktop: {
            googleAdOnSearch: {
              pos: 'search_header',
              width: 1280,
              height: 160,
            },
            googleAdOnSearchInline_3: {
              pos: 'search_inline1',
              width: 954,
              height: 118,
            },
            googleAdOnSearchInline_6: {
              pos: 'search_inline2',
              width: 954,
              height: 118,
            },
          },
        },
        bcom: {
          mweb: {},
          desktop: {},
        },
      },
    };
  case 'pdp':
    return {
      experiments: {
        mcom: '',
        bcom: '',
      },
      ad_data: {
        mcom: {
          slotId: '22026345640',
          brand: 'mcom',
          mweb: {
            googleAdOnPdpTop: { pos: 'pdp_header', width: 335, height: 94 },
            googleAdOnPdp: { pos: 'pdp_inline1', width: 335, height: 94 },
          },
          desktop: {
            googleAdOnPdpTop: {
              pos: 'pdp_header',
              width: 1280,
              height: 50,
            },
            googleAdOnPdp: { pos: 'pdp_inline1', width: 1280, height: 160 },
            googleAdOnPdpBottom: [{
              pos: 'pdp_bottom',
              width: 1280,
              height: 160,
            },
            {
              pos: 'pdp_bottom',
              width: 970,
              height: 90,
            },
            {
              pos: 'pdp_bottom',
              width: 728,
              height: 90,
            },
            ],
          },
        },
        bcom: {
          slotId: '22026345640',
          brand: 'bcom',
          mweb: {
            googleAdOnPdp: { pos: 'top', width: 343, height: 112 },
            googleAdOnPdpBottom: { pos: 'inline1', width: 343, height: 112 },
          },
          desktop: {
            googleAdOnPdp: { pos: 'top', width: 1440, height: 75 },
            googleAdOnPdpBottom: { pos: 'inline1', width: 1440, height: 198 },
          },
        },
      },
    };
  default:
    return {
      experiments: {
        mcom: '',
        bcom: '',
      },
      ad_data: {
        mcom: {
          mweb: {},
          desktop: {},
        },
        bcom: {
          mweb: {},
          desktop: {},
        },
      },
    };
  }
};
export default getPageSpecificValues;
